import { Button } from "@mui/material";
import StyledDialog from "./StyledDialog";
import { DisclosureHost } from "../hooks/use-disclosure";

interface ViewFileModalProps {
  disclosureHost: DisclosureHost;
  title?: string;
  w?: string;
  h?: string;
}

const ViewFileModal = ({
  disclosureHost,
  title = "Preview",
  w = "90vw",
  h = "calc(100svh - 120px)",
}: ViewFileModalProps) => {
  const file = disclosureHost.data;

  return (
    <StyledDialog
      open={disclosureHost.opened}
      onClose={disclosureHost.close}
      dialogTitle={title}
      dialogAction={
        <Button variant="contained" onClick={disclosureHost.close}>
          Close
        </Button>
      }
      sx={{
        "& .MuiDialog-paper": {
          width: w,
          maxWidth: w,
          maxHeight: h,
        },
      }}
    >
      {file ? (
        <iframe title={title} src={file} style={{ height: h, width: w }} />
      ) : null}
    </StyledDialog>
  );
};

export default ViewFileModal;
